
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-inspirasi/playlists/video",
      function () {
        return require("private-next-pages/video-inspirasi/playlists/video/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video-inspirasi/playlists/video"])
      });
    }
  